import { NuqsAdapter } from 'nuqs/adapters/react-router/v7'
import { useEffect } from 'react'
import { RouterProvider } from 'react-router-dom'
import ErrorBoundary from '@/components/layout/ErrorBoundary'
import { subscribeToCrossTabAuth, validateStoredAuth } from '@/lib/authGuard'
import { router } from '@/routes/router'

function App() {
  // Revalidate the persisted JWT on mount, when the tab comes back to focus
  // and on reconnect (a refresh that couldn't reach the server is retried
  // there), and keep auth in step with the app's other tabs.
  useEffect(() => {
    validateStoredAuth()
    const onFocus = () => {
      if (document.visibilityState === 'visible') validateStoredAuth()
    }
    const onOnline = () => validateStoredAuth()
    document.addEventListener('visibilitychange', onFocus)
    window.addEventListener('online', onOnline)
    const unsubscribeCrossTab = subscribeToCrossTabAuth()
    return () => {
      document.removeEventListener('visibilitychange', onFocus)
      window.removeEventListener('online', onOnline)
      unsubscribeCrossTab()
    }
  }, [])

  return (
    <ErrorBoundary>
      <NuqsAdapter>
        <RouterProvider router={router} />
      </NuqsAdapter>
    </ErrorBoundary>
  )
}

export default App
